export class Label {
    id = "";
    name = {it: ""};
    type = "text";
    datalist = {it: ""};
}
